import { environment } from '../environments/environment';

/**
 * AppSettingApi
 * APIのエンドポイント用
 */
export class AppSettingApi {

	// APIの接続先サーバ
	public static API_HOST_URL = environment.API_HOST_URL;

	////////////////////////////////
	// ログイン
	// メアド/パスワードでのログイン
	public static AUTH_LOGIN = AppSettingApi.API_HOST_URL + '/api/admin/Account/login.json';
	// パスワード未設定ユーザーにメール送信する
	public static AUTH_FORGET_PASSWORD_SEND = AppSettingApi.API_HOST_URL + '/api/admin/account/sendResetPassword.json';
	public static AUTH_CHK_PASSWORD = AppSettingApi.API_HOST_URL + '/api/admin/account/checkNowPassword.json';
	public static AUTH_RESET_PASSWORD = AppSettingApi.API_HOST_URL + '/api/admin/account/resetPassword.json';

	////////////////////////////////
	// ユーザー情報一覧
	// ログインしているユーザー情報の取得
	public static USER_GET = AppSettingApi.API_HOST_URL + '/api/admin/User/get.json';
	public static USER_GET_RELATED_DATA_LIST = AppSettingApi.API_HOST_URL + '/api/admin/User/getRelatedDataList.json';
	// ユーザーIDから情報取得
	public static USER_FROM_ID_GET = AppSettingApi.API_HOST_URL + '/api/admin/User/getUserFullData.json';
	// 1000件ずつのユーザー取得
	public static USER_LIST_GET = AppSettingApi.API_HOST_URL + '/api/admin/User/list.json';
	// 自サーバーに登録されたユーザー情報の取得
	public static USER_LIST_COUNT_GET = AppSettingApi.API_HOST_URL + '/api/admin/User/count.json';
	// 1000件ずつのユーザー取得
	public static USER_LIST_NOMED_GET = AppSettingApi.API_HOST_URL + '/api/admin/User/listNotMedicalRecord.json';
	// ユーザー情報の検索
	public static USER_LIST_SEARCH = AppSettingApi.API_HOST_URL + '/api/admin/User/search.json';
	// Orcaユーザー情報の検索
	public static USER_ORCA_LIST_SEARCH = AppSettingApi.API_HOST_URL + '/api/admin/Orca/search.json';
	// カルテ情報が存在しないユーザー数の取得
	public static USER_LIST_NOMED_COUNT_GET = AppSettingApi.API_HOST_URL + '/api/admin/User/countNotMedicalRecord.json';
	// パスワード無しユーザー取得
	public static USER_LIST_NO_PASSWORD_GET = AppSettingApi.API_HOST_URL + '/api/admin/User/listNoPass.json';
	// パスワード無しユーザー数取得
	public static USER_LIST_NO_PASSWORD_COUNT = AppSettingApi.API_HOST_URL + '/api/admin/User/noPassCount.json';
	// ORCA未紐付け患者一覧
	public static USER_UNLINKED_ORCA_PATIENT_LIST = AppSettingApi.API_HOST_URL + '/api/admin/User/unlinkedOrcaPatientList.json';
	// ユーザー仮登録
	public static USER_REGISTER_PENDING = AppSettingApi.API_HOST_URL + '/api/admin/User/registerPending.json';
	// 仮登録一覧取得
	public static USER_LIST_PENDING = AppSettingApi.API_HOST_URL + '/api/admin/User/listPending.json';
	// ハッシュ再発行
	public static USER_REISSUE_PENDING_HASH = AppSettingApi.API_HOST_URL + '/api/admin/User/reissuePendingHash.json';
	// 本登録待ち解除（仮登録取り消し）
	public static USER_CANCEL_PENDING = AppSettingApi.API_HOST_URL + '/api/admin/User/cancelPending.json';
	// ユーザー情報の新規登録
	public static USER_KARTE_INFO_GET = AppSettingApi.API_HOST_URL + '/api/admin/MedicalRecord/get.json';
	// ユーザー情報の新規登録
	public static USER_KARTE_INFO_REGISTER = AppSettingApi.API_HOST_URL + '/api/admin/MedicalRecord/register.json';
	// ユーザー情報の更新
	public static USER_KARTE_INFO_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/MedicalRecord/update.json';
	// カルテ番号からユーザー情報の取得
	public static USER_BY_MEDICAL_ID_GET = AppSettingApi.API_HOST_URL + '/api/admin/User/userByMedId.json';
	// ユーザーの登録
	public static USER_REGISTER = AppSettingApi.API_HOST_URL + '/api/admin/User/register.json';
	// ユーザーの更新
	public static USER_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/User/update.json';
	public static USER_NOTE_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/User/updateUserNote.json';
	// キャンペーンメール配信設定（配信停止フラグ）の更新
	public static USER_UPDATE_CAMPAIGN_MAIL = AppSettingApi.API_HOST_URL + '/api/admin/User/updateCampaignMail.json';
	// 性別リスト
	public static USER_GENDER_LIST = AppSettingApi.API_HOST_URL + '/api/admin/User/listGender.json';
	// ユーザーメッセージ送信
	public static USER_SEND_MESSAGE = AppSettingApi.API_HOST_URL + '/api/admin/User/sendMessage.json';
	public static USER_SEND_MESSAGE_ALL = AppSettingApi.API_HOST_URL + '/api/admin/User/sendMessageAll.json';
	// LineMessage一覧
	public static LINE_MESSAGE_USER_LIST = AppSettingApi.API_HOST_URL + '/api/external/LineMessage/getMessageUserList.json';
	public static LINE_MESSAGE_USER_LIST_PIN = AppSettingApi.API_HOST_URL + '/api/external/LineMessage/getMessageUserListPin.json';
	public static LINE_MESSAGE_USER = AppSettingApi.API_HOST_URL + '/api/external/LineMessage/getMessageUser.json';

	// LineMessage取得
	public static LINE_MESSAGE_LIST_BY_LINE_ID = AppSettingApi.API_HOST_URL + '/api/external/LineMessage/getLineMessageByLineId.json';
	// LineMessage追加取得
	public static LINE_NEW_MESSAGE_LIST_BY_LINE_ID = AppSettingApi.API_HOST_URL + '/api/external/LineMessage/getNewLineMessagesByLineId.json';
	// LineMessage送信
	public static LINE_MESSAGE_SEND = AppSettingApi.API_HOST_URL + '/api/external/LineMessage/sendMessage.json';
	public static LINE_IMAGE_SEND = AppSettingApi.API_HOST_URL + '/api/external/LineMessage/sendImage.json';
	public static LINE_PDF_SEND = AppSettingApi.API_HOST_URL + '/api/external/LineMessage/sendPdf.json';

	public static LINE_PIN_UP = AppSettingApi.API_HOST_URL + '/api/external/LineMessage/upPin.json';
	public static LINE_PIN_DOWN = AppSettingApi.API_HOST_URL + '/api/external/LineMessage/downPin.json';

	public static LINE_REMARK_ADD = AppSettingApi.API_HOST_URL + '/api/external/LineMessage/addRemark.json';
	public static LINE_REMARK_REMOVE = AppSettingApi.API_HOST_URL + '/api/external/LineMessage/removeRemark.json';
	public static LINE_REMARK_GET = AppSettingApi.API_HOST_URL + '/api/external/LineMessage/getRemark.json';
	////////////////////////////////
	// ファイル関連
	// ファイルアップロード
	public static FILE_PDF_UPLOAD = AppSettingApi.API_HOST_URL + '/api/admin/InspectionResult/upload.json';
	// ファイルリスト取得
	public static FILE_PDF_LIST_GET = AppSettingApi.API_HOST_URL + '/api/admin/InspectionResult/list.json';
	// ファイル取得
	public static FILE_PDF_GET = AppSettingApi.API_HOST_URL + '/api/admin/InspectionResult/get.json';
	// ファイル削除
	public static FILE_PDF_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/InspectionResult/delete.json';

	////////////////////////////////
	// 保険証関連
	// 取得
	public static HEALTH_INSURE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/HealthInsure/list.json';
	// URL取得
	public static HEALTH_INSURE_GET = AppSettingApi.API_HOST_URL + '/api/admin/HealthInsure/get.json';

	////////////////////////////////
	// 請求関連
	// 請求データ数取得
	public static PAYMENT_COUNT = AppSettingApi.API_HOST_URL + '/api/admin/Payment/count.json';
	// 請求リスト取得
	public static PAYMENT_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Payment/list.json';
	public static PAYMENT_ONLINE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Payment/listRelateCredit.json';
	public static PAYMENT_NO_RESERVE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Payment/listNoReserve.json';
	public static PAYMENT_NO_USER_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Payment/listNoUser.json';
	// 個人請求リスト取得
	public static PAYMENT_INDIVIDUAL_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Payment/listByUserId.json';
	public static PAYMENT_DIRTY_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Payment/listDirty.json';
	public static PAYMENT_MERGED_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Payment/listMerged.json';
	// 請求作成取得
	public static PAYMENT_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/Payment/create.json';
	public static PAYMENT_RELATE_RESERVE = AppSettingApi.API_HOST_URL + '/api/admin/Payment/relateToReserve.json';
	public static PAYMENT_MERGE = AppSettingApi.API_HOST_URL + '/api/admin/Payment/merge.json';
	public static PAYMENT_REVERT = AppSettingApi.API_HOST_URL + '/api/admin/Payment/revert.json';
	// 請求詳細取得
	public static PAYMENT_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/Payment/detail.json';
	// 請求金額変更
	public static PAYMENT_CHANGE = AppSettingApi.API_HOST_URL + '/api/admin/Payment/change.json';
	// 請求キャンセル
	public static PAYMENT_CANCEL = AppSettingApi.API_HOST_URL + '/api/admin/Payment/cancel.json';
	// 請求情報更新
	public static PAYMENT_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/Payment/update.json';
	// メッセージ送信失敗やメッセージ再送時に仕様する
	public static PAYMENT_MESSAGE_SEND = AppSettingApi.API_HOST_URL + '/api/admin/Payment/resendMessage.json';
	// メッセージ送信失敗やメッセージ再送時に仕様する
	public static PAYMENT_UPLOAD_RECEIPT = AppSettingApi.API_HOST_URL + '/api/admin/Payment/uploadReceipt.json';
	// ORCAから請求情報を取得する
	public static PAYMENT_ORCA_INVOICE = AppSettingApi.API_HOST_URL + '/api/admin/Orca/invoice.json';
	// ORCAから領収書をDLして取得
	public static PAYMENT_ORCA_RECEIPT = AppSettingApi.API_HOST_URL + '/api/admin/Orca/receipt.json';
	// ORCAから処方箋のDLして保存
	public static PRESCRIPTION_FROM_RESERVE_ORCA_PRESCRIPTION = AppSettingApi.API_HOST_URL + '/api/admin/Orca/createPrescriptionFromReservation.json';
	// お薬・処方箋対応の新規作成
	public static PAYMENT_CREATE_EXAM_AFTER_PROCESS = AppSettingApi.API_HOST_URL + '/api/admin/Payment/createExamAfterProcess.json';
	// お薬・処方箋の設定更新
	public static PAYMENT_UPDATE_EXAM_AFTER_PROCESS = AppSettingApi.API_HOST_URL + '/api/admin/Payment/updateExamAfterProcess.json';
	// お薬・処方箋の詳細取得
	public static PAYMENT_GET_EXAM_AFTER_PROCESS_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/Payment/getExamAfterProcessDetail.json';
	////////////////////////////////
	// PCR検査数取得
	public static PCR_EXAMINE_COUNT = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/examineCount.json';
	// PCR検査関連
	public static PCR_EXAMINE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/listExamine.json';
	// 検体番号からPCR検査問診データ取得
	public static PCR_EXAMINE_FROM_SPEC = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/getExamineFromSpec.json';

	// PCR稼働装置の総数取得
	public static PCR_WORK_MACHINE_COUNT = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/workEquipCount.json';
	// 稼働一覧取得
	public static PCR_WORK_MACHINE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/listEquipmentWork.json';
	// 検体IDから稼働装置を取得
	public static PCR_WORK_MACHINE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/getEquipmentWorkFromExamine.json';
	// 検査と検体番号マスタは紐付いているが、検体番号マスタと検査装置が紐付いていないデータの取得
	public static PCR_WORK_MACHINE_UNASSOCIATED_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/listUnassociatedEquipWork.json';
	// 稼働装置の登録
	public static PCR_WORK_MACHINE_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/saveEquipWork.json';
	// 稼働装置の更新
	public static PCR_WORK_MACHINE_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/updateEquipWork.json';
	// PCR問診票
	public static PCR_INTERVIEW_USER_MST = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/listQuestion.json';
	// PCR問診マスタ
	public static PCR_INTERVIEW_USER_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/saveInterview.json';
	// 問診データの取得
	public static PCR_INTERVIEW_GET = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/getInterviewData.json';
	// 問診データの更新
	public static PCR_INTERVIEW_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/updateInterview.json';

	// 検査備考の更新
	public static PCR_EXAMINE_REMARK_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/updateExaminePcrExamineRemark.json';
	// 検査結果データの保存
	public static PCR_EXAMINE_RESULT_ANNOUNCE_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/saveExamineAnnounceResult.json';
	// 検査結果データの保存
	public static PCR_EXAMINE_RESULT_MAIL_STATUS_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/saveExamineMailStatusResult.json';
	// 検査結果データの保存
	public static PCR_EXAMINE_RESULT_NEGATIVE_CERT_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/saveExamineNegativeResult.json';
	// 検査結果(resultId)の保存
	public static PCR_EXAMINE_RESULT_ID_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/saveExamineResultId.json';

	// 検査結果データの検体番号IDの更新
	public static PCR_EXAMINE_SPEC_ID_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/updateExamineSpecimenId.json';

	// メール送信
	public static PCR_MESSAGE_SEND = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/sendResultMail.json';

	// 本人連絡ステータスリスト
	public static PCR_ANNOUNCE_STATUS = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/listAnnounceStatus.json';
	// メール送信ステータスリスト
	public static PCR_MAIL_SEND_STATUS = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/listMailSendStatus.json';
	// PCR問診キャンセル
	public static PCR_CANCEL_EXAMINE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/cancelExamine.json';


	/////////////////////////
	// PCR証明書登録
	// 陰性証明書登録（JA）
	public static PCR_NEGATIVE_CERT_JA_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/saveNegativeCertJa.json';
	// 陰性証明書登録（JA）
	public static PCR_POSITIVE_CERT_JA_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/savePositiveCertJa.json';
	// 陰性証明書登録（EN）
	public static PCR_NEGATIVE_CERT_EN_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/saveNegativeCertEn.json';
	// 陰性証明書（JA）の一時データを取得する
	public static PCR_NEGATIVE_CERT_TMP_JA_GET = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/getNegativeCertTmpJa.json';
	// 陽性証明書（JA）の一時データを取得する
	public static PCR_POSITIVE_CERT_TMP_JA_GET = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/getPositiveCertTmpJa.json';
	// 陰性証明書（EN）の一時データを取得する
	public static PCR_NEGATIVE_CERT_TMP_EN_GET = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/getNegativeCertTmpEn.json';
	// 結果取得
	public static PCR_RESULT_DOWNLOAD = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/download.json';

	////////////////////////////////
	// マスタ管理
	///////////////////////////////

	// PCR関連
	// 検体マスタの取得
	public static PCR_SPECIMEN_MST_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/listSpecimenMst.json';
	// 検体マスタの取得
	public static PCR_SPECIMEN_MST_FIND = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/findSpecimenMst.json';
	// 検体番号の発行
	public static PCR_SPECIMEN_MST_ISSUE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/issueSpecimenNumber.json';
	// 検体マスタの作成
	public static PCR_SPECIMEN_MST_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/saveSpecimen.json';
	// 検体マスタの更新
	public static PCR_SPECIMEN_MST_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/updateSpecimen.json';
	// 検体マスタの更新(印刷ステータスの更新)
	public static PCR_SPECIMEN_MST_PRINT_STATUS_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/updatePcrSpecimenPrintStatus.json';
	// 装置一覧取得
	public static PCR_MACHINE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/listEquipment.json';
	// 装置マスタの登録
	public static PCR_MACHINE_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/saveEquipment.json';
	// 装置マスタの更新
	public static PCR_MACHINE_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/updateEquipment.json';

	// 結果マスタの取得
	// TODO: 削除予定（現状使用されているため残留）
	public static PCR_WORK_RESULT_MST_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Pcr/listResultMst.json';

	// マスタ管理系
	// 結果マスタリストの取得
	public static MST_PCR_RESULT_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Master/listResult.json';
	// 結果マスタリストに新規登録
	public static MST_PCR_RESULT_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/Master/saveResult.json';
	// 結果マスタリストに新規登録
	public static MST_PCR_RESULT_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/Master/updateResult.json';
	// 結果マスタリストに新規登録
	public static MST_PCR_RESULT_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/Master/deleteResult.json';

	// 採取検体マスタリストの取得
	public static MST_PCR_SAMPLE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Master/listSample.json';
	// 採取検体マスタリストに新規登録
	public static MST_PCR_SAMPLE_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/Master/saveSample.json';
	// 採取検体マスタリストに更新
	public static MST_PCR_SAMPLE_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/Master/updateSample.json';
	// 採取検体マスタリストに削除
	public static MST_PCR_SAMPLE_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/Master/deleteSample.json';

	////////////////////////////////
	// 性病検査申込
	////////////////////////////////
	public static VD_ORDER_LIST = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/list.json';
	public static VD_ORDER_LIST_FULL = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/listFull.json';
	public static VD_ORDER_LIST_BY_USER = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/listByUser.json';
	public static VD_ORDER_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/detail.json';
	public static VD_ORDER_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/save.json';
	public static VD_ORDER_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/update.json';
	public static VD_ORDER_UPDATE_ORDER_DATE = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/updateOrderDate.json';
	public static VD_ORDER_CANCEL = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/cancel.json';
	// メール送信キュー作成
	public static VD_ORDER_RESULT_MESSAGE_SEND = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/sendResultMail.json';
	// 検査結果ファイルの生成
	public static VD_ORDER_INSPECTION_RESULT_FILE_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/saveVdInspectionResultFile.json';
	public static VD_ORDER_INSPECTION_RESULT_FILE_SAVE_V2 = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/saveVdInspectionResultFileV2.json';
	// 申し込み詳細からの検査結果入力
	public static VD_ORDER_GET_SPECIMEN_INSPECTION_LIST = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/getSpecimenInspectionList.json';
	public static VD_ORDER_SAVE_SPECIMEN_INSPECTION_RESULT = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/saveSpecimenInspectionResult.json';

	// 申し込みの検査に付随する検査結果ファイルの取得
	public static VD_ORDER_GET_INSPECTION_FILE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/getInspectionFileList.json';
	// 検査結果ファイルの削除
	public static VD_ORDER_DELETE_RESULT_FILE = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/deleteVdInspectionResultFile.json';

	public static VD_ORDER_UPDATE_MEMO_TO_USER = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/updateResultMessage.json';
	public static VD_ORDER_GET_RESULT_JUDGEMENT_INPUT_INITIAL_DATA = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/getResultJudgementInputInitialData.json';
	public static VD_ORDER_GET_RESULT_UPDATE_JUDGEMENT = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/updateResultJudgement.json';

	public static VD_ORDER_INSPECTION_RESULT_SEND_ALL_MESSAGE_INITIAL_DATA = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/getResultSendAllMessageViewInitialData.json';
	public static VD_ORDER_INSPECTION_RESULT_SEND_MESSAGE_TO_ALL_USER_INITIAL_DATA = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/getResultSendMessageToAllUserViewInitialData.json';
	public static VD_ORDER_INSPECTION_RESULT_NOTIFIED_INITIAL_DATA = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/getResultNotifiedViewInitialData.json';

	////////////////////////////////
	// 性病検査一覧
	////////////////////////////////
	public static VD_INSPECTION_RESULT_MESSAGE_SEND = AppSettingApi.API_HOST_URL + '/api/admin/VdInspection/sendResultMessage.json';
	public static VD_INSPECTION_RESULT_ALL_SEND = AppSettingApi.API_HOST_URL + '/api/admin/VdInspection/sendMessageAllInspectionByUser.json';
	public static VD_INSPECTION_RESULT_SEND_TO_ALL_USER = AppSettingApi.API_HOST_URL + '/api/admin/VdInspection/sendInspectionResultMessageToAllUser.json';

	public static VD_INSPECTION_RESULT_NOTIFIED = AppSettingApi.API_HOST_URL + '/api/admin/VdInspection/notifiedInspectionResult.json';
	public static VD_INSPECTION_RESULT_GET_RENDER_MESSAGE = AppSettingApi.API_HOST_URL + '/api/admin/VdInspection/getRenderMessage.json';
	////////////////////////////////
	// 性病検査結果
	////////////////////////////////
	// 検査主体と検査方法
	public static VD_PLACE_INSPECTION_METHOD_LIST = AppSettingApi.API_HOST_URL + '/api/admin/VdResult/getExamPlaceAndInspectionMethod.json';

	// 検体
	public static VD_RESULT_SPECIMEN_LIST = AppSettingApi.API_HOST_URL + '/api/admin/VdResult/getVdSpecimen.json';
	public static VD_RESULT_SPECIMEN_LIST_BY_VD_INSPECTION_ITEM_MST_ID = AppSettingApi.API_HOST_URL + '/api/admin/VdResult/getVdSpecimenByVdInspectionItemMstId.json';
	public static VD_RESULT_SPECIMEN_LIST_BY_VD_INSPECTION_ITEM_GROUP = AppSettingApi.API_HOST_URL + '/api/admin/VdResult/getVdSpecimenByVdInspectionItemGroup.json';
	public static VD_RESULT_SPECIMEN_LIST_BY_MST_EQUIPMENT_WORK_ID = AppSettingApi.API_HOST_URL + '/api/admin/VdResult/getVdSpecimenByMstEquipmentWorkId.json';
	public static VD_RESULT_SPECIMEN_LIST_BY_RESULT_INPUT_TYPE_MANUAL = AppSettingApi.API_HOST_URL + '/api/admin/VdResult/getVdSpecimenByResultInputTypeManual.json';

	// 検査項目
	public static VD_RESULT_VD_INSPECTION_ITEM = AppSettingApi.API_HOST_URL + '/api/admin/VdResult/getVdInspectionItem.json';
	public static VD_RESULT_VD_INSPECTION_ITEM_LIST = AppSettingApi.API_HOST_URL + '/api/admin/VdResult/getVdInspectionItemList.json';
	public static VD_RESULT_VD_INSPECTION_ITEM_GROUP_LIST = AppSettingApi.API_HOST_URL + '/api/admin/VdResult/getVdInspectionItemGroupList.json';

	// 検査結果ファイルの保存・削除
	public static VD_INSPECTION_RESULT_FILE_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/updateInspectionFile.json';
	public static VD_INSPECTION_RESULT_FILE_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/VdOrder/deleteInspectionFile.json';

	// 単体の検査結果入力画面用のデータ取得
	public static VD_INSPECTION_RESULT_GET_VD_SPECIMEN_VD_INSPECTION_ITEM_INPUT_VIEW_DATA = AppSettingApi.API_HOST_URL + '/api/admin/VdResult/getVdSpecimenVdInspectionItemInputViewData.json';
	public static VD_INSPECTION_RESULT_SAVE_VD_SPECIMEN_VD_INSPECTION_ITEM = AppSettingApi.API_HOST_URL + '/api/admin/VdResult/saveVdSpecimenVdInspectionItem.json';

	// 性病検査結果の保存
	// ファイルインポート 汎用 1ファイルが1つの検査結果の場合
	public static VD_INSPECTION_RESULT_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionResult/save.json';
	public static VD_INSPECTION_RESULT_SAVE_BY_SPECIMEN_NUMBER = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionResult/saveBySpecimenNumber.json';
	public static VD_INSPECTION_SUB_ITEM_RESULT_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionResult/saveSubItem.json';

	// 検査結果一括保存 サブ項目
	public static VD_INSPECTION_RESULT_SAVE_SUB_ITEM_BATCH = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionResult/saveSubItemResultBatch.json';
	// ファイルインポート Cobas4800のクラミジア・淋病を同時検査する試薬の場合
	public static VD_INSPECTION_RESULT_COBAS4800_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionResult/saveCobas4800.json';
	// ファイルインポート Cobas4800のクラミジア・淋病を同時検査する試薬の場合かつ
	// ファイルの検体設置位置を無視する場合
	public static VD_INSPECTION_RESULT_COBAS4800_SAVE_MATCH_DATE = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionResult/saveCobas4800MatchDate.json';
	// 手動の場合
	public static VD_INSPECTION_RESULT_SAVE_MANUALLY = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionResult/saveManually.json';
	// ファイルから結果インポート済みのデータを編集
	public static VD_INSPECTION_RESULT_EDIT = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionResult/editResult.json';
	// cobas4800 の検査結果判定用のパターン取得
	public static VD_INSPECTION_RESULT_GET_COBAS4800_XML_JUDGMENT_PATTERN_LIST = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionResult/getVdCobas4800XmlJudgmentPatternList.json';

	// 検査項目のサブ項目(菌)の取得・保存
	public static VD_INSPECTION_RESULT_SAVE_VD_INSPECTION_ITEM_SUB = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionResult/saveVdInspectionItemSub.json';
	// レポート
	public static VD_REPORT_GET_FROM_TO = AppSettingApi.API_HOST_URL + '/api/admin/VdReport/getReportFromTo.json';
	public static VD_MONTHLY_REPORT_GET_FROM_TO = AppSettingApi.API_HOST_URL + '/api/admin/VdReport/getMonthlyReportFromTo.json';
	public static VD_DIARY_REPORT_GET_FROM_TO = AppSettingApi.API_HOST_URL + '/api/admin/VdReport/getDiaryReportFromTo.json';

	// 性病検査 検査数レポート
	public static VD_INSPECTION_REPORT_GET_FROM_TO = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionReport/getReportFromTo.json';
	public static VD_INSPECTION_DIARY_REPORT_GET_FROM_TO = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionReport/getDiaryReportFromTo.json';

	// PCR検査レポート用CSV
	public static VD_PCR_REPORT_WELLNEST_GET_FROM_TO = AppSettingApi.API_HOST_URL + '/api/admin/VdPcrReport/getWellnestReportFromTo.json';
	public static VD_PCR_REPORT_WELLNEST_FILE_GET_FROM_TO = AppSettingApi.API_HOST_URL + '/api/admin/VdPcrReport/getWellnestReportFileFromTo.json';
	public static VD_PCR_REPORT_PCR_GET_FROM_TO = AppSettingApi.API_HOST_URL + '/api/admin/VdPcrReport/getPcrReportFromTo.json';
	public static VD_PCR_REPORT_PCR_FILE_GET_FROM_TO = AppSettingApi.API_HOST_URL + '/api/admin/VdPcrReport/getPcrReportFileFromTo.json';

	////////////////////////////////
	// 性病検査マスタ管理
	////////////////////////////////
	// 検査名
	public static VD_COURSE_MST_LIST = AppSettingApi.API_HOST_URL + '/api/admin/VdCourseMst/list.json';
	public static VD_COURSE_MST_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/VdCourseMst/create.json';
	public static VD_COURSE_MST_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/VdCourseMst/update.json';
	public static VD_COURSE_MST_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/VdCourseMst/delete.json';
	public static VD_COURSE_MST_UPDATE_STATUS = AppSettingApi.API_HOST_URL + '/api/admin/VdCourseMst/updateStatus.json';
	public static VD_COURSE_MST_UPDATE_PRIORITY = AppSettingApi.API_HOST_URL + '/api/admin/VdCourseMst/updatePriority.json';
	public static VD_COURSE_MST_UPDATE_PRICE = AppSettingApi.API_HOST_URL + '/api/admin/VdCourseMst/updatePrice.json';
	// 検査項目
	public static VD_INSPECTION_ITEM_MST_LIST = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemMst/list.json';
	public static VD_INSPECTION_ITEM_MST_LIST_FULL = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemMst/listFull.json';
	public static VD_INSPECTION_ITEM_MST_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemMst/save.json';
	public static VD_INSPECTION_ITEM_MST_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemMst/delete.json';
	// 関連データのリストも取得する用
	public static VD_INSPECTION_ITEM_MST_LIST_AND_RELATED_DATA_LIST = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemMst/listAndRelatedDataList.json';
	public static VD_INSPECTION_ITEM_MST_LIST_AND_RELATED_DATA_LIST_WITH_SUB_ITEMS_ONLY = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemMst/listAndRelatedDataListWithSubItemsOnly.json';

	// 検査項目の詳細取得 (単体)
	public static VD_INSPECTION_ITEM_MST_GET_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemMst/getDetail.json';

	// 検査項目の検査対象(菌)
	public static VD_INSPECTION_ITEM_SUB_MST_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemMst/saveVdInspectionItemSubMst.json';
	public static VD_INSPECTION_ITEM_SUB_MST_LIST = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemMst/listVdInspectionItemSubMst.json';
	public static VD_INSPECTION_ITEM_SUB_MST_FORM_INITIAL_DATA = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemMst/getVdInspectionItemSubMstFormInitialData.json';

	// 検査項目グループ
	public static VD_INSPECTION_ITEM_GROUP_MST_LIST = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemGroupMst/list.json';
	public static VD_INSPECTION_ITEM_GROUP_MST_LIST_FULL = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemGroupMst/listFull.json';
	public static VD_INSPECTION_ITEM_GROUP_MST_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemGroupMst/save.json';
	public static VD_INSPECTION_ITEM_GROUP_MST_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemGroupMst/delete.json';

	// 検査項目サブグループ
	public static VD_INSPECTION_ITEM_GROUP_SUB_MST_GET = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemGroupMst/getSubDetail.json';
	public static VD_INSPECTION_ITEM_GROUP_SUB_MST_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemGroupMst/createSub.json';
	public static VD_INSPECTION_ITEM_GROUP_SUB_MST_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemGroupMst/updateSub.json';
	public static VD_INSPECTION_ITEM_GROUP_SUB_MST_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemGroupMst/deleteSub.json';
	public static VD_INSPECTION_ITEM_GROUP_SUB_ITEM_RELATE = AppSettingApi.API_HOST_URL + '/api/admin/VdInspectionItemGroupMst/relateGroupSubItem.json';

	// バーコード取得
	public static VD_SPECIMEN_BARCORD_LIST_BY_VD_ORDER_ID = AppSettingApi.API_HOST_URL + '/api/admin/VdSpecimen/getBarcordByOrderId.json';
	// 機器設置自動採番する対象検査検体の取得
	public static VD_SPECIMEN_GET_UNPLACED_SPECIMEN_LIST = AppSettingApi.API_HOST_URL + '/api/admin/VdSpecimen/getSpecimenListForEquipmentPlacement.json';
	// 検査機器の稼働に対して検体の設置位置を保存
	public static VD_SPECIMEN_SAVE_POSITION_FOR_EPIC_WORK = AppSettingApi.API_HOST_URL + '/api/admin/VdSpecimen/savePositionForEpicWork.json';

	// 性別のリスト取得
	public static GENDER_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Gender/list.json';

	// TODO: 削除
	public static MST_VD_RESULT_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Master/listResult.json';
	// 結果マスタリストに新規登録
	public static MST_VD_RESULT_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/Master/saveResult.json';
	// 結果マスタリストに新規登録
	public static MST_VD_RESULT_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/Master/updateResult.json';
	// 結果マスタリストに新規登録
	public static MST_VD_RESULT_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/Master/deleteResult.json';

	// 国リストを取得
	public static MST_COUNTRY_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Master/countryList.json';

	// メッセージテンプレート関連
	// メッセージテンプレートリスト取得
	public static MESSAGE_TEMPLATE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MailTemplate/list.json';
	// メッセージテンプレート詳細取得
	public static MESSAGE_TEMPLATE_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/MailTemplate/detail.json';
	// メッセージテンプレート作成
	public static MESSAGE_TEMPLATE_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MailTemplate/create.json';
	// メッセージテンプレート編集
	public static MESSAGE_TEMPLATE_EDIT = AppSettingApi.API_HOST_URL + '/api/admin/MailTemplate/change.json';
	// メッセージテンプレート削除
	public static MESSAGE_TEMPLATE_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MailTemplate/delete.json';
	// メッセージテンプレートカテゴリ
	public static MESSAGE_TEMPLATE_CATEGORY_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MailTemplateCategory/list.json';
	public static MESSAGE_TEMPLATE_CATEGORY_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/MailTemplateCategory/detail.json';
	public static MESSAGE_TEMPLATE_CATEGORY_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MailTemplateCategory/create.json';
	public static MESSAGE_TEMPLATE_CATEGORY_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/MailTemplateCategory/update.json';
	public static MESSAGE_TEMPLATE_CATEGORY_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MailTemplateCategory/delete.json';



	// 規約マスタ関連
	public static AGREEMENT_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstAgreement/getList.json';
	public static AGREEMENT_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/MstAgreement/detail.json';
	public static AGREEMENT_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MstAgreement/create.json';
	public static AGREEMENT_EDIT = AppSettingApi.API_HOST_URL + '/api/admin/MstAgreement/update.json';
	public static AGREEMENT_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MstAgreement/delete.json';

	// 規約表示対象設定
	public static AGREEMENT_GET_RESERVE_SETTING_INITIAL_DATA = AppSettingApi.API_HOST_URL + '/api/admin/MstAgreement/getReserveSettingViewData.json';
	public static AGREEMENT_TARGET_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/MstAgreement/updateAgreementTarget.json';


	public static ANALYTICS_GET_MONTHLY = AppSettingApi.API_HOST_URL + '/api/admin/Analytics/monthly.json';
	public static ANALYTICS_GET_DAILY = AppSettingApi.API_HOST_URL + '/api/admin/Analytics/daily.json';

	////////////////////////////////
	// HTMLメール
	////////////////////////////////
	public static HTML_MAIL_LIST = AppSettingApi.API_HOST_URL + '/api/admin/HtmlMail/list.json';
	public static HTML_MAIL_SEND = AppSettingApi.API_HOST_URL + '/api/admin/HtmlMail/send.json';

	////////////////////////////////
	// HTMLメール画像
	////////////////////////////////
	public static HTML_MAIL_IMAGE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/HtmlMailImage/list.json';
	public static HTML_MAIL_IMAGE_UPLOAD = AppSettingApi.API_HOST_URL + '/api/admin/HtmlMailImage/upload.json';
	public static HTML_MAIL_IMAGE_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/HtmlMailImage/update.json';
	public static HTML_MAIL_IMAGE_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/HtmlMailImage/delete.json';
	public static HTML_MAIL_IMAGE_DISABLE = AppSettingApi.API_HOST_URL + '/api/admin/HtmlMailImage/disable.json';
	public static HTML_MAIL_IMAGE_ENABLE = AppSettingApi.API_HOST_URL + '/api/admin/HtmlMailImage/enable.json';

	////////////////////////////////
	// アプリケーション共通マスタ管理
	////////////////////////////////
	// VD検査結果用
	public static RESULT_TYPE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/ResultType/list.json';
	public static RESULT_SUB_ITEM_LIST = AppSettingApi.API_HOST_URL + '/api/admin/ResultType/getVdInspectionSubItemResultList.json';
	public static RESULT_GET_VD_SPECIMEN_VD_INSPECTION_ITEM_STATUS_LIST = AppSettingApi.API_HOST_URL + '/api/admin/ResultType/getVdSpecimenVdInspectionItemStatusList.json';
	// 結果マスタ
	public static MST_RESULT_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstResult/list.json';
	public static MST_RESULT_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MstResult/create.json';
	public static MST_RESULT_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/MstResult/update.json';
	public static MST_RESULT_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MstResult/delete.json';

	// 採取検体マスタ
	public static MST_SAMPLE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstSample/list.json';
	public static MST_SAMPLE_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MstSample/create.json';
	public static MST_SAMPLE_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/MstSample/update.json';
	public static MST_SAMPLE_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MstSample/delete.json';

	// 検査方法マスタ
	public static MST_INSPECTION_METHOD_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/MstInspectionMethod/detail.json';
	public static MST_INSPECTION_METHOD_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstInspectionMethod/list.json';
	public static MST_INSPECTION_METHOD_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MstInspectionMethod/create.json';
	public static MST_INSPECTION_METHOD_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/MstInspectionMethod/update.json';
	public static MST_INSPECTION_METHOD_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MstInspectionMethod/delete.json';
	public static MST_INSPECTION_METHOD_GET_RESULT_INPUT_TYPE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstInspectionMethod/getResultInputTypeList.json';

	// PCR_検査方法マスタ
	public static MST_PCR_INSPECTION_METHOD_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Master/listInspectionMethod.json';
	public static MST_PCR_INSPECTION_METHOD_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/Master/saveInspectionMethod.json';
	public static MST_PCR_INSPECTION_METHOD_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/Master/updateInspectionMethod.json';
	public static MST_PCR_INSPECTION_METHOD_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/Master/deleteInspectionMethod.json';

	// 検査主体マスタCRUD
	public static MST_EXAM_PLACE_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/MstExamPlace/detail.json';
	public static MST_EXAM_PLACE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstExamPlace/list.json';
	public static MST_EXAM_PLACE_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MstExamPlace/create.json';
	public static MST_EXAM_PLACE_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/MstExamPlace/update.json';
	public static MST_EXAM_PLACE_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MstExamPlace/delete.json';

	// 試薬マスタCRUD
	public static MST_REAGENT_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/MstReagent/detail.json';
	public static MST_REAGENT_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstReagent/list.json';
	public static MST_REAGENT_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/MstReagent/save.json';
	public static MST_REAGENT_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MstReagent/delete.json';
	public static MST_REAGENT_RESULT_FILE_TYPE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstReagent/resultFileTypeList.json';

	// 保管棚マスタCRUD
	public static MST_SHELF_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstShelf/list.json';
	public static MST_SHELF_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/MstShelf/save.json';
	public static MST_SHELF_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MstShelf/delete.json';
	public static MST_SHELF_EMPTY_MST_SHELF_HISTORY_SPECIMEN_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstShelf/getEmptyMstShelfHistorySpecimenList.json';
	// 保管履歴
	public static MST_SHELF_HISTORY_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstShelfHistory/list.json';
	public static MST_SHELF_HISTORY_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MstShelfHistory/create.json';
	public static MST_SHELF_HISTORY_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/MstShelfHistory/update.json';
	public static MST_SHELF_HISTORY_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MstShelfHistory/delete.json';
	// 保管検体
	public static MST_SHELF_HISTORY_SPECIMEN_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstShelfHistory/detail.json';

	// 検査装置
	public static MST_EQUIPMENT_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstEquipment/list.json';
	public static MST_EQUIPMENT_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/MstEquipment/save.json';
	public static MST_EQUIPMENT_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MstEquipment/delete.json';

	// 検査装置稼働履歴
	public static MST_EQUIPMENT_WORK_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstEquipmentWork/list.json';
	public static MST_EQUIPMENT_WORK_LIST_BY_MST_REAGENT_ID = AppSettingApi.API_HOST_URL + '/api/admin/MstEquipmentWork/listByMstReagentId.json';
	public static MST_EQUIPMENT_WORK_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/MstEquipmentWork/detail.json';
	public static MST_EQUIPMENT_WORK_LIST_WITH_NO_RESULT_SET = AppSettingApi.API_HOST_URL + '/api/admin/MstEquipmentWork/listWithNoResultSet.json';

	// 検査マスタ
	public static MST_DISEASE_EXAM_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/MstDiseaseExam/detail.json';
	public static MST_DISEASE_EXAM_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstDiseaseExam/getList.json';
	public static MST_DISEASE_EXAM_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MstDiseaseExam/create.json';
	public static MST_DISEASE_EXAM_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/MstDiseaseExam/update.json';
	public static MST_DISEASE_EXAM_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MstDiseaseExam/delete.json';

	// 検査管理
	public static DISEASE_EXAM_ORDER_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/DiseaseExamOrder/detail.json';
	public static DISEASE_EXAM_ORDER_LIST = AppSettingApi.API_HOST_URL + '/api/admin/DiseaseExamOrder/getList.json';
	public static DISEASE_EXAM_ORDER_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/DiseaseExamOrder/create.json';
	public static DISEASE_EXAM_ORDER_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/DiseaseExamOrder/update.json';
	public static DISEASE_EXAM_ORDER_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/DiseaseExamOrder/delete.json';
	public static DISEASE_EXAM_ORDER_RESULT_MESSAGE_SEND = AppSettingApi.API_HOST_URL + '/api/admin/DiseaseExamOrder/sendResultMail.json';

	// 予約管理
	// 予約
	public static RESERVATION_LIST_BY_CLINIC_ID = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/getListByClinicId.json';
	public static RESERVATION_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/search.json';
	public static RESERVATION_LIST_BY_PATIENT = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/getListByPatient.json';
	public static RESERVATION_LIST_FROM_TO = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/getListFromTo.json';
	public static RESERVATION_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/create.json';
	public static RESERVATION_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/update.json';
	public static RESERVATION_CANCEL = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/cancel.json';
	public static RESERVATION_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/detail.json';
	// 予約に適用可能なクーポン一覧（予約者本人が保有する有効・未使用クーポン）の取得
	public static RESERVATION_GET_APPLICABLE_COUPONS = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/getApplicableCoupons.json';
	// 予約へクーポンを適用（coupon_userをUSEDにし、予約と紐付ける）
	public static RESERVATION_APPLY_COUPON = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/applyCoupon.json';
	// 予約からクーポンを解除（紐付けを削除し、coupon_userをUNUSEDに戻す）
	public static RESERVATION_RELEASE_COUPON = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/releaseCoupon.json';
	public static RESERVATION_SEND_MESSAGE = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/sendMessage.json';
	public static RESERVATION_GET_CREATE_VIEW_DATA = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/getCreateViewData.json';
	public static RESERVATION_GET_UPDATE_VIEW_DATA = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/getUpdateViewData.json';
	public static RESERVATION_GET_SELECT_DATETIME_VIEW_DATA = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/getSelectDateViewData.json';
	public static RESERVATION_UPDATE_STATUS = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/updateStatus.json';
	public static RESERVATION_GET_SEARCH_CONDITIONS = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/getSearchConditions.json';
	public static RESERVATION_CHANGE_TMP_USER_TO_REGISTERED_USER = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/changeTempUserToRegisteredUser.json';
	public static RESERVATION_LINK_ORCA_PATIENT = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/linkOrcaPatient.json';
	public static RESERVATION_UPDATE_PREPARATION_STATUS = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/updatePreparationStatus.json';
	public static RESERVATION_GET_NEXT_RESERVE = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/getNextReserve.json';
	public static RESERVATION_SET_PRESCRIPTION = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/setPrescription.json';
	public static RESERVATION_FORCE_CHANGE_DOCTOR = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/forceChangeDoctor.json';
	public static RESERVATION_CREATE_ONLINE_INSURE_AGREEMENT = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/createOnlineInsureAgreement.json';
	public static RESERVATION_GET_ONLINE_INSURE_AGREEMENT_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/getOnlineInsureAgreementList.json';
	// 予約完了メッセージの送信
	public static RESERVATION_SEND_COMPLETE_MESSAGE = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/sendCompleteMessage.json';
	// 予約変更メッセージの送信
	public static RESERVATION_SEND_UPDATE_MESSAGE = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/sendUpdateMessage.json';
	// 予約キャンセルメッセージの送信
	public static RESERVATION_SEND_CANCEL_MESSAGE = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/sendCancelMessage.json';

	// キャンペーン
	public static CAMPAIGN_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Campaign/getList.json';
	public static CAMPAIGN_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/Campaign/getDetail.json';
	public static CAMPAIGN_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/Campaign/create.json';
	public static CAMPAIGN_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/Campaign/update.json';
	public static CAMPAIGN_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/Campaign/delete.json';

	// キャンペーン画像
	public static CAMPAIGN_IMAGEMAP_UPLOAD = AppSettingApi.API_HOST_URL + '/api/admin/CampaignImagemap/upload.json';
	public static CAMPAIGN_IMAGEMAP_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/CampaignImagemap/delete.json';
	// 新形式への移行により管理画面からは未使用。旧APIの互換参照用。
	public static CAMPAIGN_IMAGE_UPLOAD = AppSettingApi.API_HOST_URL + '/api/admin/CampaignImage/upload.json';
	public static CAMPAIGN_IMAGE_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/CampaignImage/delete.json';

	// クーポン
	public static COUPON_LINK_USERS = AppSettingApi.API_HOST_URL + '/api/admin/Coupon/linkUsers.json';
	public static COUPON_UNLINK_USER = AppSettingApi.API_HOST_URL + '/api/admin/Coupon/unlinkUser.json';
	public static COUPON_CHECK_CODE_AVAILABLE = AppSettingApi.API_HOST_URL + '/api/admin/Coupon/checkCodeAvailable.json';
	// ユーザー保有クーポン一覧取得（ユーザー情報詳細画面のクーポン一覧用）
	public static COUPON_GET_LIST_BY_USER = AppSettingApi.API_HOST_URL + '/api/admin/Coupon/getListByUser.json';
	// クーポン紐付けユーザー一覧取得（ページング。キャンペーン詳細画面の対象ユーザー一覧用）
	public static COUPON_GET_USER_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Coupon/getUserList.json';

	// リマインド
	public static REMIND_LIST_BY_TARGET_RESERVE = AppSettingApi.API_HOST_URL + '/api/admin/Remind/getListByTargetReserve.json';
	public static REMIND_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/Remind/detail.json';
	public static REMIND_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/Remind/create.json';
	public static REMIND_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/Remind/update.json';
	public static REMIND_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/Remind/delete.json';
	public static REMIND_GET_CREATE_INITIAL_DATA = AppSettingApi.API_HOST_URL + '/api/admin/Remind/getCreateInitialData.json';
	public static REMIND_GET_UPDATE_INITIAL_DATA = AppSettingApi.API_HOST_URL + '/api/admin/Remind/getUpdateInitialData.json';

	// 予約問診
	public static RESERVATION_INTERVIEW_GET_SETTINGS_INITIAL_DATA = AppSettingApi.API_HOST_URL + '/api/admin/ReservationInterview/getSettingInitialData.json';
	public static RESERVATION_INTERVIEW_GET_RESEVE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/getReservationInterview.json';
	public static RESERVATION_INTERVIEW_LIST = AppSettingApi.API_HOST_URL + '/api/admin/ReservationInterview/getList.json';
	public static RESERVATION_INTERVIEW_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/ReservationInterview/create.json';
	public static RESERVATION_INTERVIEW_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/ReservationInterview/delete.json';

	// 処方箋のFAX送信
	public static RESERVATION_SEND_PRESCRIPTION_BY_FAX = AppSettingApi.API_HOST_URL + '/api/admin/Reservation/sendPrescriptionByFax.json';

	// 医師
	public static MST_DOCTOR_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstDoctor/getList.json';
	public static MST_DOCTOR_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MstDoctor/create.json';
	public static MST_DOCTOR_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/MstDoctor/update.json';
	public static MST_DOCTOR_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MstDoctor/delete.json';

	public static MST_DOCTOR_SIGN_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/MstDoctor/updateSign.json';
	public static MST_DOCTOR_SIGN_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MstDoctor/deleteSign.json';

	// クリニック
	public static MST_CLINIC_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstClinic/getList.json';
	public static MST_CLINIC_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MstClinic/create.json';
	public static MST_CLINIC_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/MstClinic/update.json';
	public static MST_CLINIC_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MstClinic/delete.json';
	public static MST_CLINIC_SETTING_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstClinic/getSettingList.json';
	// 診療科
	public static MST_DEPARTMENT_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstDepartment/getList.json';
	public static MST_DEPARTMENT_LIST_BY_CLINIC_ID = AppSettingApi.API_HOST_URL + '/api/admin/MstDepartment/getListByClinicId.json';
	public static MST_DEPARTMENT_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MstDepartment/create.json';
	public static MST_DEPARTMENT_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/MstDepartment/update.json';
	public static MST_DEPARTMENT_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MstDepartment/delete.json';
	public static MST_DEPARTMENT_JOIN_DOCTOR = AppSettingApi.API_HOST_URL + '/api/admin/MstDepartment/joinDoctor.json';
	public static MST_DEPARTMENT_UPDATE_EXAM = AppSettingApi.API_HOST_URL + '/api/admin/MstDepartment/updateExam.json';
	public static MST_DEPARTMENT_UPDATE_EXAM_TIME = AppSettingApi.API_HOST_URL + '/api/admin/MstDepartment/updateExamTime.json';
	// 診察内容マスタ
	public static MST_EXAMINATION_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstExamination/getList.json';
	public static MST_EXAMINATION_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MstExamination/create.json';
	public static MST_EXAMINATION_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/MstExamination/update.json';
	public static MST_EXAMINATION_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MstExamination/delete.json';

	// クリニック休日設定
	public static MST_HOLIDAY_CLINIC_DAY_OF_WEEK_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/getClinicDayOfWeekList.json';
	public static MST_HOLIDAY_CLINIC_DAY_OF_WEEK_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/createClinicDayOfWeek.json';
	public static MST_HOLIDAY_CLINIC_DAY_DATE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/getClinicDayDateList.json';
	public static MST_HOLIDAY_CLINIC_DAY_DATE_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/createClinicDayDate.json';
	public static MST_HOLIDAY_CLINIC_GET_TIME_LIST_FOR_DAY_OF_WEEK = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/getClinicTimeListForDayOfWeek.json';

	// 医師休日設定
	public static MST_HOLIDAY_DOCTOR_CREATE_DAY_DATE = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/createDoctorDayDate.json';
	public static MST_HOLIDAY_DOCTOR_LIST_BY_CLINIC_ID = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/getDoctorListByClinicId.json';
	public static MST_HOLIDAY_DOCTOR_DAY_OF_WEEK_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/getDoctorDayOfWeekList.json';
	public static MST_HOLIDAY_DOCTOR_DAY_OF_WEEK_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/createDoctorDayOfWeek.json';
	public static MST_HOLIDAY_DOCTOR_DAY_DATE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/getDoctorDayDateList.json';

	// 診療科休日設定
	public static MST_HOLIDAY_DEPARTMENT_LIST_BY_CLINIC_ID = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/getDepartmentListByClinicId.json';
	public static MST_HOLIDAY_DEPARTMENT_DAY_OF_WEEK_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/getDepartmentDayOfWeekList.json';
	public static MST_HOLIDAY_DEPARTMENT_DAY_OF_WEEK_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/createDepartmentDayOfWeek.json';
	public static MST_HOLIDAY_DEPARTMENT_DAY_DATE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/getDepartmentDayDateList.json';
	public static MST_HOLIDAY_DEPARTMENT_DAY_DATE_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/createDepartmentDayDate.json';
	// 休日更新
	public static MST_HOLIDAY_DAY_OF_WEEK_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/updateDayOfWeek.json';
	public static MST_HOLIDAY_DAY_DATE_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/updateDayDate.json';
	// 休日削除
	public static MST_HOLIDAY_DELETE_BY_ID = AppSettingApi.API_HOST_URL + '/api/admin/MstHoliday/deleteById.json';

	// 予約問診
	public static MST_RESERVATION_INTERVIEW_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/MstReservationInterview/detail.json';
	public static MST_RESERVATION_INTERVIEW_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MstReservationInterview/getList.json';
	public static MST_RESERVATION_INTERVIEW_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/MstReservationInterview/create.json';
	public static MST_RESERVATION_INTERVIEW_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/MstReservationInterview/update.json';
	public static MST_RESERVATION_INTERVIEW_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/MstReservationInterview/delete.json';

	// 郵便番号から住所を取得
	//public static ADDRESS_GET = AppSettingApi.API_HOST_URL + '/api/external/getAddress.json';
	public static ADDRESS_GET = AppSettingApi.API_HOST_URL + '/api/admin/User/getAddress.json';

	////////////////////////////////
	// ORCA診療行為管理
	////////////////////////////////
	public static ORCA_GET_PATIENT_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/Orca/getPatientDetail.json';
	public static ORCA_LIST_MEDICAL_CONTENT = AppSettingApi.API_HOST_URL + '/api/admin/Orca/listMedicalContent.json';
	public static ORCA_GET_MEDICAL_CONTENT_BY_ID = AppSettingApi.API_HOST_URL + '/api/admin/Orca/getMedicalContentById.json';
	public static ORCA_SEARCH_MEDICAL_CONTENT = AppSettingApi.API_HOST_URL + '/api/admin/Orca/searchMedicalContent.json';
	public static ORCA_SEARCH_MEDICAL_CONTENT_USERS = AppSettingApi.API_HOST_URL + '/api/admin/Orca/searchMedicalContentUsers.json';
	public static ORCA_MEDICAL_CONTENT_IMPORTED_DATES = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicalContent/importedDates.json';
	public static ORCA_GET_RAW_MEDICAL_CONTENT = AppSettingApi.API_HOST_URL + '/api/admin/Orca/getRawMedicalContent.json';

	// 診療行為管理
	public static ORCA_MEDICINE_LIST = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicine/getList.json';
	public static ORCA_MEDICINE_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicine/create.json';
	public static ORCA_MEDICINE_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicine/update.json';
	public static ORCA_MEDICINE_UPDATE_DISABLED = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicine/updateDisabled.json';
	public static ORCA_MEDICINE_UPDATE_EXPIRY_DAYS = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicine/updateExpiryDays.json';
	public static ORCA_MEDICINE_FETCH = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicine/fetch.json';
	public static ORCA_MEDICINE_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicine/delete.json';

	// 診療行為グループ管理
	public static ORCA_MEDICINE_GROUP_LIST = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicineGroup/getList.json';
	public static ORCA_MEDICINE_GROUP_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicineGroup/create.json';
	public static ORCA_MEDICINE_GROUP_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicineGroup/update.json';
	public static ORCA_MEDICINE_GROUP_LINK_MEDICINES = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicineGroup/linkMedicines.json';
	public static ORCA_MEDICINE_GROUP_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicineGroup/delete.json';

	// 診療行為カテゴリ管理
	public static ORCA_MEDICINE_CATEGORY_LIST = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicineCategory/getList.json';
	public static ORCA_MEDICINE_CATEGORY_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicineCategory/create.json';
	public static ORCA_MEDICINE_CATEGORY_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicineCategory/update.json';
	public static ORCA_MEDICINE_CATEGORY_LINK_MEDICINES = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicineCategory/linkMedicines.json';
	public static ORCA_MEDICINE_CATEGORY_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicineCategory/delete.json';

	// 診療分類別の薬切れ日計算設定
	public static ORCA_MEDICINE_CLASS_SETTING_LIST = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicineClassSetting/getList.json';
	public static ORCA_MEDICINE_CLASS_SETTING_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicineClassSetting/create.json';
	public static ORCA_MEDICINE_CLASS_SETTING_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicineClassSetting/update.json';
	public static ORCA_MEDICINE_CLASS_SETTING_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicineClassSetting/delete.json';
	public static ORCA_MEDICINE_CLASS_SETTING_FETCH = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicineClassSetting/fetch.json';

	// 薬切れ日管理
	public static ORCA_MEDICINE_EXPIRY_GENERATE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicineExpiry/generate.json';
	public static ORCA_MEDICINE_EXPIRY_LIST = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMedicineExpiry/list.json';

	// メッセージ配信リスト管理
	public static ORCA_MESSAGE_DELIVERY_LIST_CREATE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMessageDeliveryList/createList.json';
	public static ORCA_MESSAGE_DELIVERY_LIST_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMessageDeliveryList/updateList.json';
	public static ORCA_MESSAGE_DELIVERY_LIST_GET_LISTS = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMessageDeliveryList/getLists.json';
	public static ORCA_MESSAGE_DELIVERY_LIST_GENERATE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMessageDeliveryList/generate.json';
	public static ORCA_MESSAGE_DELIVERY_LIST_ADD = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMessageDeliveryList/add.json';
	public static ORCA_MESSAGE_DELIVERY_LIST_ITEMS = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMessageDeliveryList/list.json';
	public static ORCA_MESSAGE_DELIVERY_LIST_SEND = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMessageDeliveryList/send.json';
	public static ORCA_MESSAGE_DELIVERY_LIST_DISABLE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMessageDeliveryList/disable.json';
	public static ORCA_MESSAGE_DELIVERY_LIST_ENABLE = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMessageDeliveryList/enable.json';
	public static ORCA_MESSAGE_DELIVERY_LIST_DISABLE_BY_REPRESCRIPTION = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMessageDeliveryList/disableByReprescription.json';
	public static ORCA_MESSAGE_DELIVERY_LIST_SEND_HTML = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMessageDeliveryList/sendHtmlMail.json';
	public static ORCA_MESSAGE_DELIVERY_LIST_SEND_CAMPAIGN = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMessageDeliveryList/sendCampaignMessage.json';
	// 対象ユーザー指定版（リスト内の指定 user_id の active 配信先のみへ送信。送信エラー者・未反応者への再送用）
	public static ORCA_MESSAGE_DELIVERY_LIST_SEND_HTML_TO_USERS = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMessageDeliveryList/sendHtmlMailToUsers.json';
	public static ORCA_MESSAGE_DELIVERY_LIST_SEND_CAMPAIGN_TO_USERS = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMessageDeliveryList/sendCampaignMessageToUsers.json';
	// 配信先コピー（別の配信リストへ複製する。コピー元リストは変更されない）
	// 対象の決め方ごとにエンドポイントが分かれている：
	//   ByIds        : 画面でチェックした配信先ID（item_ids）を指定する
	//   ByConditions : 一覧の絞り込み条件に一致する配信先を全件（ページングに関係なく）対象にする
	public static ORCA_MESSAGE_DELIVERY_LIST_COPY_ITEMS_BY_IDS = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMessageDeliveryList/copyItemsByIds.json';
	public static ORCA_MESSAGE_DELIVERY_LIST_COPY_ITEMS_BY_CONDITIONS = AppSettingApi.API_HOST_URL + '/api/admin/OrcaMessageDeliveryList/copyItemsByConditions.json';


	// 問診
	public static MST_INTERVIEW_GET = AppSettingApi.API_HOST_URL + '/api/admin/InterviewSet/interview.json';
	public static MST_INTERVIEW_SET = AppSettingApi.API_HOST_URL + '/api/admin/InterviewSet/detail.json';
	public static MST_INTERVIEW_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/InterviewSet/save.json';
	public static MST_INTERVIEW_SET_LIST = AppSettingApi.API_HOST_URL + '/api/admin/InterviewSet/list.json';
	public static MST_INTERVIEW_SET_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/InterviewSet/delete.json';

	public static MST_INTERVIEW_UNIT = AppSettingApi.API_HOST_URL + '/api/admin/InterviewUnit/detail.json';
	public static MST_INTERVIEW_UNIT_LIST = AppSettingApi.API_HOST_URL + '/api/admin/InterviewUnit/list.json';
	public static MST_INTERVIEW_UNIT_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/InterviewUnit/save.json';
	public static MST_INTERVIEW_UNIT_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/InterviewUnit/delete.json';

	public static MST_INTERVIEW_DETAIL = AppSettingApi.API_HOST_URL + '/api/admin/InterviewDetail/detail.json';
	public static MST_INTERVIEW_DETAIL_LIST = AppSettingApi.API_HOST_URL + '/api/admin/InterviewDetail/list.json';
	public static MST_INTERVIEW_DETAIL_SAVE = AppSettingApi.API_HOST_URL + '/api/admin/InterviewDetail/save.json';
	public static MST_INTERVIEW_DETAIL_SAVE_IMAGE = AppSettingApi.API_HOST_URL + '/api/admin/InterviewDetail/saveImage.json';
	public static MST_INTERVIEW_DETAIL_DELETE = AppSettingApi.API_HOST_URL + '/api/admin/InterviewDetail/delete.json';
	public static MST_INTERVIEW_DETAIL_REMOVE = AppSettingApi.API_HOST_URL + '/api/admin/InterviewDetail/remove.json';

	public static INTERVIEW_GET = AppSettingApi.API_HOST_URL + '/api/admin/InterviewAnswer/interview.json';
	public static INTERVIEW_UPDATE = AppSettingApi.API_HOST_URL + '/api/admin/InterviewAnswer/update.json';


	// 自費薬購入問診
	public static MED_INTERVIEW_GET = AppSettingApi.API_HOST_URL + '/api/admin/MedInterview/get.json';
	public static MED_INTERVIEW_LIST = AppSettingApi.API_HOST_URL + '/api/admin/MedInterview/list.json';
	public static MED_INTERVIEW_UPDATE_REMARK = AppSettingApi.API_HOST_URL + '/api/admin/MedInterview/updateRemark.json';
	public static MED_INTERVIEW_UPDATE_STATUS = AppSettingApi.API_HOST_URL + '/api/admin/MedInterview/updateStatus.json';
	public static MED_INTERVIEW_UPDATE_DOCTOR_AGREE = AppSettingApi.API_HOST_URL + '/api/admin/MedInterview/updateDoctorAppd.json';
	public static MED_INTERVIEW_UPDATE_MR_AGREE = AppSettingApi.API_HOST_URL + '/api/admin/MedInterview/updateMRAppd.json';
	public static MED_INTERVIEW_UPDATE_PURCHASE_AGREE = AppSettingApi.API_HOST_URL + '/api/admin/MedInterview/updatePurchaseAppd.json';
	public static MED_INTERVIEW_UPDATE_INTERVIEW_AGREE_ALL = AppSettingApi.API_HOST_URL + '/api/admin/MedInterview/updateInterviewAppd.json';
	public static MED_INTERVIEW_UPDATE_INTERVIEW_AGREE = AppSettingApi.API_HOST_URL + '/api/admin/MedInterview/updateInterviewUnitAppd.json';
}
